
<tilby-dialog-toolbar (confirm)="confirm()" [title]="title"/>

<tilby-dialog-content>
    @if(roomForm) {
        <tilby-magic-form [form]="roomForm"/>
    }
</tilby-dialog-content>

